<template>
    <div class="dropdown filter_item">
        <button class="btn m-r-5 btn-default waves-effect waves-light dropdown-toggle" :class="{'btn-success': selected_amenities.length > 0}" type="button" data-toggle="dropdown">
            Comodidades
        </button>

        <div class="dropdown-menu dropdown-menu-right arrow-dropdown-menu arrow-menu-right dropdown-lg">
            <p class="h5 m-b-15">Comodidades</p>

            <div class="form-group">
                <div v-for="amenity in amenities" :key="amenity.id" class="checkbox checkbox-success">
                    <input :name="'amenity_' + amenity.id"
                            :id="'amenity_' + amenity.id"
                            type="checkbox"
                            :value="amenity.id"
                            v-model="model">
                    <label :for="'amenity_' + amenity.id">
                        {{ amenity.name }}
                    </label>
                </div>
            </div>

            <div class="row m-t-30">
                <div class="col-xs-12">
                    <button @click="filter()" class="btn btn-block btn-success">Filtrar</button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            model: this.$store.getters.getFilter.amenities || [],
        }
    },
    watch: {
        selected_amenities: {
            handler(newVal) {
                this.model = newVal;
            },
        }
    },
    computed: {
        selected_amenities() {
            return this.$store.getters.getFilter.amenities || [];
        },
        amenities() {
            return this.$store.getters.getAmenities;
        },
    },
    methods: {
        filter() {
            this.$store.commit('setFilter', {amenities: this.model});
            this.$emit('filter');
            $(this.$el).find('.dropdown-toggle').dropdown('toggle');
        }
    }
}
</script>